import React from "react";
import StudiengangListBase from "./StudiengangListBase";

const StudiengangList: React.FC<{}> = () => {
  return <StudiengangListBase variables={{ where: { ausbildungsArtId: { eq: 1 } } }} />;
};

export default StudiengangList;
